var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoicePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5814 7.72661C9.73242 7.49542 10.0423 7.43044 10.2734 7.58146C11.6223 8.46263 12.5 10.1282 12.5 12.0001C12.5 13.8719 11.6223 15.5375 10.2734 16.4187C10.0423 16.5697 9.73242 16.5047 9.5814 16.2735C9.43038 16.0423 9.49536 15.7325 9.72655 15.5815C10.7629 14.9045 11.5 13.5715 11.5 12.0001C11.5 10.4286 10.7629 9.09565 9.72655 8.41866C9.49536 8.26763 9.43038 7.95779 9.5814 7.72661Z",
    fill: "#286D71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6263 4.66787C12.8097 4.46146 13.1257 4.44283 13.3321 4.62626C15.2697 6.34807 16.5 9.01879 16.5 12C16.5 14.9812 15.2697 17.6519 13.3321 19.3738C13.1257 19.5572 12.8097 19.5386 12.6263 19.3321C12.4428 19.1257 12.4615 18.8097 12.6679 18.6263C14.3817 17.1032 15.5 14.7094 15.5 12C15.5 9.29062 14.3817 6.89678 12.6679 5.37375C12.4615 5.19032 12.4428 4.87428 12.6263 4.66787Z",
    fill: "#286D71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6452 1.64769C15.8398 1.45174 16.1564 1.45063 16.3523 1.64521C18.9017 4.17685 20.5 7.88349 20.5 12C20.5 16.1165 18.9017 19.8232 16.3523 22.3548C16.1564 22.5494 15.8398 22.5483 15.6452 22.3523C15.4506 22.1564 15.4517 21.8398 15.6477 21.6452C18.0014 19.3079 19.5 15.8596 19.5 12C19.5 8.14045 18.0014 4.69212 15.6477 2.35479C15.4517 2.16021 15.4506 1.84363 15.6452 1.64769Z",
    fill: "#286D71"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 2,
    fill: "#0F7B7D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicePlay);
export default __webpack_public_path__ + "static/media/voice-play.6609f02207b9e72481cc9c51eb5cdb75.svg";
export { ForwardRef as ReactComponent };